/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Status_QueuedInputs */

const vi_print_admin_status_queued = /** @type {(inputs: Print_Admin_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ in`)
};

/**

* @param {Print_Admin_Status_QueuedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_status_queued = /** @type {((inputs?: Print_Admin_Status_QueuedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Status_QueuedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_status_queued(inputs)
});